import { render } from "./FraksiFraksi.vue?vue&type=template&id=73d69134"
import script from "./FraksiFraksi.vue?vue&type=script&lang=js"
export * from "./FraksiFraksi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__